import { TRoomMessageDB } from '../../types/db';
import db from './db';
import { TMessage } from '../../types/rooms';
import { TNullableAttachment } from '../../types/attachments';

class RoomMessageModel implements TRoomMessageDB {
  id: string;
  from: string;
  text: string;
  sender: string;
  stamp: string;
  roomId: string;
  attachment?: TNullableAttachment;

  constructor({ id, from, text, sender, stamp, attachment, roomId }: TRoomMessageDB) {
    this.id = id;
    this.from = from;
    this.text = text;
    this.sender = sender;
    this.stamp = stamp;
    this.roomId = roomId;
    if (attachment) {
      this.attachment = attachment;
    }
  }

  static async getMessagesByRoomId(roomId: string): Promise<TMessage[]> {
    return await db.roomMessages.where('roomId').equals(roomId).sortBy('stamp');
  }

  static async getLastMessageStampByRoomId(roomId: string): Promise<any> {
    const messages = await db.roomMessages.where('roomId').equals(roomId).sortBy('stamp');
    if (messages.length) {
      return messages[messages.length - 1].stamp;
    }
    return '';
  }

  async save() {
    return await db.roomMessages.put({
      id: this.id,
      from: this.from,
      text: this.text,
      sender: this.sender,
      stamp: this.stamp,
      roomId: this.roomId,
      attachment: this.attachment,
    });
  }
}

export default RoomMessageModel;
